import { CustomButtonModel } from '@/models/CustomButtonModel'
import { api } from '@/services/api'

type FetchCustomButtonParams = {
  companyId: string
  ownerId: string
}

export type FetchCustomButtonResponse = {
  customButtons: CustomButtonModel[]
}

export async function fetchCustomButtons(params: FetchCustomButtonParams) {
  const queryParams = `?ownerId=${params.ownerId}&companyId=${params.companyId}`

  const response = await api.get<FetchCustomButtonResponse>(`/custom-buttons/find-by-company-id${queryParams}`)
  return response.data
}
